"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AuthEvents {
    static addListenRenew(fn) {
        window.addEventListener(AuthEvents.EVENTS.RENEW, fn);
    }
    static removeListenRenew(fn) {
        window.removeEventListener(AuthEvents.EVENTS.RENEW, fn);
    }
    static addListenRenewError(fn) {
        window.addEventListener(AuthEvents.EVENTS.RENEW_ERROR, fn);
    }
    static removeListenRenewError(fn) {
        window.removeEventListener(AuthEvents.EVENTS.RENEW_ERROR, fn);
    }
    static addListenUser(fn) {
        window.addEventListener(AuthEvents.EVENTS.USER, fn);
    }
    static removeListenUser(fn) {
        window.removeEventListener(AuthEvents.EVENTS.USER, fn);
    }
    static dispatchUser(user) {
        window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.USER, { detail: user }));
    }
    static dispatchRenew() {
        window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.RENEW));
    }
    static dispatchRenewError(error) {
        window.dispatchEvent(new CustomEvent(AuthEvents.EVENTS.RENEW_ERROR, { detail: error.message }));
    }
}
exports.default = AuthEvents;
AuthEvents.EVENTS = {
    RENEW: 'cas-js:renew',
    RENEW_ERROR: 'cas-js:renew-error',
    USER: 'cas-js:user'
};
